import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42586997"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center gap-2 gap-lg-3 siteFilter" }
const _hoisted_2 = { class: "m-0" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "btn btn-icon btn-white border btn-circle btn-sm m-1 position-absolute z-index-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-diagram-3 fs-3 text-primary" })
], -1))
const _hoisted_4 = {
  class: "border border-secondary min-w-350px filterbox",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-start",
  "data-kt-menu-target": `#vz-filter-data-globalFilter`,
  id: "vz-filter-global-filter-trigger"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "chip text-white" }
const _hoisted_11 = { class: "chip text-white mr-2" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "chip text-white" }
const _hoisted_17 = { class: "chip text-white" }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "chip text-white" }
const _hoisted_23 = { class: "chip text-white mr-2" }
const _hoisted_24 = { key: 3 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "chip text-white" }
const _hoisted_29 = { class: "chip text-white mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VZFilter = _resolveComponent("VZFilter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_VZFilter, {
        options: _ctx.tableFilter,
        defaultFilter: {},
        viewName: "globalFilter",
        onFilterChange: _ctx.setSelectedSite,
        onDefaultFilter: _cache[8] || (_cache[8] = (length) => _ctx.postAlterFilter(length)),
        ref: "globalFilter"
      }, {
        actions: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            (
                _ctx.siteAlsoSelected ||
                _ctx.postalCodeNames.length ||
                _ctx.cityNames.length ||
                _ctx.stateNames.length
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_ctx.siteAlsoSelected)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                        (_ctx.selectedSites.length < 3)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedSites, (data, index) => {
                                return (_openBlock(), _createElementBlock("label", {
                                  class: "chip text-white",
                                  key: index
                                }, [
                                  _createTextVNode(_toDisplayString(_ctx.selectedSites[index]?.text) + " ", 1),
                                  (_ctx.selectedSites && _ctx.selectedSites.length > 0)
                                    ? (_openBlock(), _createElementBlock("i", {
                                        key: 0,
                                        class: "close fas fa-times text-white",
                                        onClick: _withModifiers(($event: any) => (_ctx.removeSite(index)), ["stop"])
                                      }, null, 8, _hoisted_8))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                              _createElementVNode("label", _hoisted_10, [
                                _createTextVNode(_toDisplayString(_ctx.selectedSites[0]?.text) + " ", 1),
                                (_ctx.selectedSites && _ctx.selectedSites.length > 0)
                                  ? (_openBlock(), _createElementBlock("i", {
                                      key: 0,
                                      class: "close fas fa-times text-white",
                                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.removeSite(0)), ["stop"]))
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("label", _hoisted_11, [
                                _createTextVNode(_toDisplayString(_ctx.selectedSites[1]?.text) + " ", 1),
                                (_ctx.selectedSites && _ctx.selectedSites.length > 0)
                                  ? (_openBlock(), _createElementBlock("i", {
                                      key: 0,
                                      class: "close fas fa-times text-white",
                                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.removeSite(1)), ["stop"]))
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _createTextVNode(" + " + _toDisplayString(_ctx.selectedSites.length - 2), 1)
                            ]))
                      ]))
                    : (_ctx.postalCodeNames.length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                          (_ctx.postalCodeNames.length < 3)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.postalCodeNames, (p) => {
                                  return (_openBlock(), _createElementBlock("label", {
                                    key: p,
                                    class: "chip text-white"
                                  }, [
                                    _createTextVNode(_toDisplayString(p) + " ", 1),
                                    _createElementVNode("i", {
                                      class: "close fas fa-times text-white",
                                      onClick: _withModifiers(($event: any) => (_ctx.removePostalCode(p)), ["stop"])
                                    }, null, 8, _hoisted_14)
                                  ]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                _createElementVNode("label", _hoisted_16, [
                                  _createTextVNode(_toDisplayString(_ctx.postalCodeNames[0]) + " ", 1),
                                  _createElementVNode("i", {
                                    class: "close fas fa-times text-white",
                                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.removePostalCode(_ctx.postalCodeNames[0])), ["stop"]))
                                  })
                                ]),
                                _createElementVNode("label", _hoisted_17, [
                                  _createTextVNode(_toDisplayString(_ctx.postalCodeNames[1]) + " ", 1),
                                  _createElementVNode("i", {
                                    class: "close fas fa-times text-white",
                                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.removePostalCode(_ctx.postalCodeNames[1])), ["stop"]))
                                  })
                                ]),
                                _createTextVNode(" + " + _toDisplayString(_ctx.postalCodeNames.length - 2), 1)
                              ]))
                        ]))
                      : (_ctx.cityNames.length > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                            (_ctx.cityNames.length < 3)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cityNames, (c) => {
                                    return (_openBlock(), _createElementBlock("label", {
                                      key: c,
                                      class: "chip text-white"
                                    }, [
                                      _createTextVNode(_toDisplayString(c) + " ", 1),
                                      _createElementVNode("i", {
                                        class: "close fas fa-times text-white",
                                        onClick: _withModifiers(($event: any) => (_ctx.removeCity(c)), ["stop"])
                                      }, null, 8, _hoisted_20)
                                    ]))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                  _createElementVNode("label", _hoisted_22, [
                                    _createTextVNode(_toDisplayString(_ctx.cityNames[0]) + " ", 1),
                                    _createElementVNode("i", {
                                      class: "close fas fa-times text-white",
                                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.removeCity(_ctx.cityNames[0])), ["stop"]))
                                    })
                                  ]),
                                  _createElementVNode("label", _hoisted_23, [
                                    _createTextVNode(_toDisplayString(_ctx.cityNames[1]) + " ", 1),
                                    _createElementVNode("i", {
                                      class: "close fas fa-times text-white",
                                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.removeCity(_ctx.cityNames[1])), ["stop"]))
                                    })
                                  ]),
                                  _createTextVNode(" + " + _toDisplayString(_ctx.cityNames.length - 2), 1)
                                ]))
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_24, [
                            (_ctx.stateNames.length < 3)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stateNames, (s) => {
                                    return (_openBlock(), _createElementBlock("label", {
                                      key: s,
                                      class: "chip text-white"
                                    }, [
                                      _createTextVNode(_toDisplayString(s) + " ", 1),
                                      _createElementVNode("i", {
                                        class: "close fas fa-times text-white",
                                        onClick: _withModifiers(($event: any) => (_ctx.removeState(s)), ["stop"])
                                      }, null, 8, _hoisted_26)
                                    ]))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_27, [
                                  _createElementVNode("label", _hoisted_28, [
                                    _createTextVNode(_toDisplayString(_ctx.stateNames[0]) + " ", 1),
                                    _createElementVNode("i", {
                                      class: "close fas fa-times text-white",
                                      onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.removeState(_ctx.stateNames[0])), ["stop"]))
                                    })
                                  ]),
                                  _createElementVNode("label", _hoisted_29, [
                                    _createTextVNode(_toDisplayString(_ctx.stateNames[1]) + " ", 1),
                                    _createElementVNode("i", {
                                      class: "close fas fa-times text-white",
                                      onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.removeState(_ctx.stateNames[1])), ["stop"]))
                                    })
                                  ]),
                                  _createTextVNode(" + " + _toDisplayString(_ctx.stateNames.length - 2), 1)
                                ]))
                          ]))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["options", "onFilterChange"])
    ])
  ]))
}